import { useDispatch } from 'react-redux';

import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { TwoFactorAuthenticationSetup } from 'components/TwoFactorAuthenticationSetup/TwoFactorAuthenticationSetup';

import { disable2FA, enable2FA, updateUser } from 'api/user-slice';

export const TwoFactorAuthenticationEnforcementModal = ({
  user,
  visble,
  messagePopUp = () => {},
  onSuccess = () => {},
  setLoading = () => {},
}) => {
  const dispatch = useDispatch();

  const onUserUpdate = data => dispatch(updateUser({ id: user.id, data }));
  const onEnable2FA = data => dispatch(enable2FA({ id: user.id, data }));
  const onDisable2FA = () => dispatch(disable2FA(user.id));

  return (
    <AnimatedModal title="Set up Two-factor Authentication" visible={visble} small noClose>
      <TwoFactorAuthenticationSetup
        user={user}
        onEnable2FA={onEnable2FA}
        onDisable2FA={onDisable2FA}
        setLoading={setLoading}
        onUserUpdate={onUserUpdate}
        messagePopUp={messagePopUp}
        onSuccess={onSuccess}
      />
    </AnimatedModal>
  );
};
